import { createStore } from 'vuex' 
import login from './modules/login'; 
import product from './modules/product';
import cart from './modules/cart';
import UserMenuAndPermissions from './modules/user_menu_and_permissions';
import createPersistedState from "vuex-persistedstate";
export default createStore({
  modules: { 
    login, 
    product,
    cart,
    UserMenuAndPermissions,
  },
  plugins: [createPersistedState()],
})